import * as React from "react";
import styled from "styled-components";
import Textfield from "../Merchant/Textfield";
import Box from "../Box";
import Selectfield from "../Merchant/Selectfield";
import MultiDateSelector from "../MultiDateSelector";
import Datefield from "../Events/Datefield";
import DropdownCheckbox from "./DropdownCheckbox";
import Button from "../Button";
import { Colors, DYNAMIC_PROMO_TYPES } from "../../config/Constants";

interface Props {
  onChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  value: any;
  error: any;
  dynamicPromoType: any;
  onUpdateDetails: any;
  onChangeDetails: any;
  onProductSelect: any;
}

const DynamicPromoForm: React.FC<Props> = ({
  onChange,
  value,
  error,
  dynamicPromoType,
  onUpdateDetails,
  onChangeDetails,
  onProductSelect,
}) => {
  return (
    <>
      <StyledPageHeader>Dynamic Promotion</StyledPageHeader>
      <Box>
        <FormGrid>
          <FieldWrapper>
            <Selectfield
              label="Dynamic Promotion Type"
              data={DYNAMIC_PROMO_TYPES}
              name="dynamicPromoType"
              value={dynamicPromoType}
              onChange={onChange}
              helperText={error?.["dynamicPromoType"]}
              //   required
            />
          </FieldWrapper>
          <FieldWrapper />
          <FieldWrapper />
          {dynamicPromoType && (
            <>
              <FieldWrapper>
                <Selectfield
                  label="Active"
                  data={[
                    {
                      label: "Active",
                      value: "true",
                    },
                    {
                      label: "Inactive",
                      value: "false",
                    },
                  ]}
                  name="isEnabled"
                  value={value.isEnabled}
                  onChange={onChange}
                  helperText={error?.["isEnabled"]}
                  required
                />
              </FieldWrapper>
              {dynamicPromoType !== "dynamicPromotion" && (
                <>
                  <FieldWrapper>
                    <Textfield
                      name="promoCode"
                      label="Promo Code"
                      placeholder="Enter Promo Code"
                      onChange={onChange}
                      value={value.promoCode}
                      helperText={error?.["promoCode"]}
                      required
                    />
                  </FieldWrapper>
                  {dynamicPromoType !== "dynamicProductPriceDiscount" && (
                    <FieldWrapper>
                      <Textfield
                        type="number"
                        name="discountPercentage"
                        label="Discount Percentage"
                        placeholder="Enter Discount Percentage"
                        onChange={onChange}
                        value={value.discountPercentage}
                        helperText={error?.["discountPercentage"]}
                        required
                      />
                    </FieldWrapper>
                  )}
                  {dynamicPromoType === "dynamicProductPriceDiscount" && (
                    <FieldWrapper>
                      <Textfield
                        type="number"
                        name="discountedPrice"
                        label="Discounted Price"
                        placeholder="Enter Discounted Price"
                        onChange={onChange}
                        value={value.discountedPrice}
                        helperText={error?.["discountedPrice"]}
                        required
                      />
                    </FieldWrapper>
                  )}
                </>
              )}
              {dynamicPromoType !== "specialDiscount" && (
                <>
                  <FieldWrapper>
                    <MultiDateSelector
                      fullWidth
                      label="Restricted Dates"
                      placeholder="Select Dates"
                      onDateSelect={onChange}
                      required={false}
                      helperText={""}
                      name="restrictedDate"
                      value={(value.restrictedDate || []).map((dateStr: any) =>
                        dateStr.replace(/-/g, "/")
                      )}
                    />
                  </FieldWrapper>
                  <FieldWrapper>
                    <DropdownCheckbox
                      name="product"
                      label="Product"
                      data={value.products}
                      required
                      helperText={error?.["products"]}
                      disabled={false}
                      placeholder="Select product"
                      onProductSelect={onProductSelect}
                    />
                  </FieldWrapper>
                </>
              )}
              <FieldWrapper>
                <Datefield
                  name="startDate"
                  label="Start Date"
                  onChange={onChange}
                  placeholder="Select date"
                  value={value.startDate}
                  required
                  helperText={error?.["startDate"]}
                />
              </FieldWrapper>
              <FieldWrapper>
                <Datefield
                  name="endDate"
                  label="End Date"
                  onChange={onChange}
                  placeholder="Select date"
                  value={value.endDate}
                  required
                  helperText={error?.["endDate"]}
                />
              </FieldWrapper>
            </>
          )}
        </FormGrid>
        {dynamicPromoType === "dynamicPromotion" && (
          <>
            <Gap height="24px" />
            <StyledHeader>Details</StyledHeader>
            {value.details.map((data: any, idx: any) => (
              <FormRow>
                <FieldWrapper>
                  <Textfield
                    name="minQty"
                    label="Min. Qty"
                    placeholder="Enter Min. Qty"
                    onChange={(e) =>
                      onChangeDetails(e.target.value, e.target.name, idx)
                    }
                    value={value.details[idx]["minQty"]}
                    helperText={error?.details?.[idx]?.["minQty"]}
                    required
                  />
                </FieldWrapper>
                <FieldWrapper>
                  <Textfield
                    name="freeQty"
                    label="Free Qty."
                    placeholder="Enter Free Qty."
                    onChange={(e) =>
                      onChangeDetails(e.target.value, e.target.name, idx)
                    }
                    value={value.details[idx]["freeQty"]}
                    helperText={error?.details?.[idx]?.["freeQty"]}
                    required
                  />
                </FieldWrapper>
                <FieldWrapper>
                  <div
                    style={{
                      marginTop: "1rem",
                      display: "flex",
                      gap: "0.5rem",
                    }}
                  >
                    {value.details?.length > 1 && (
                      <Button
                        label="Remove"
                        onClick={() => onUpdateDetails(idx, "remove")}
                        color={Colors.white}
                        width="100px"
                        outlineColor={Colors.red}
                        fontColor={Colors.red}
                      />
                    )}
                    {value.details?.length - 1 === idx && (
                      <Button
                        label="Add"
                        onClick={() => onUpdateDetails(idx, "add")}
                        color={Colors.red}
                        width="100px"
                        outlineColor="transparent"
                        fontColor={Colors.white}
                      />
                    )}
                  </div>
                </FieldWrapper>
              </FormRow>
            ))}
          </>
        )}
        {dynamicPromoType && (
          <Note>
            <strong style={{ fontWeight: 900 }}>
              Note: Only the data for the currently selected dynamic promotion
              type will be saved. All other types will be marked as inactive,
              and their data will not be retained. All past dates are
              automatically removed.
            </strong>
          </Note>
        )}
      </Box>
    </>
  );
};

const Note = styled.div`
  border-radius: 4px;
  color: ${Colors.blackOpacity};
  font-size: 12px;
  margin-top: 24px;
  font-style: italic;
  strong {
    // font-style: italic;
    font-weight: 700; // or 900 if your font supports it
    color: ${Colors.black}; // Optional: make it stand out
  }
`;

const StyledPageHeader = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  margin-top: 1.5rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const StyledHeader = styled.div`
  font-size: 1rem;
  font-family: "Poppins-Medium";
  //   line-height: 1.75rem;
  margin-bottom: 0.5rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const FieldWrapper = styled.div`
  flex: 1;
  @media only screen and (max-width: 768px) {
    margin-top: 0.5rem;
  }
`;

const FormGrid = styled.div`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: 1fr 1fr 1fr;
  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
  @media only screen and (max-width: 468px) {
    grid-template-columns: 1fr;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.5rem;
  }
`;

const FormRow = styled.div`
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;

interface GapProps {
  height: string;
  height2?: string;
}

export const Gap = styled.div<GapProps>`
  height: ${(GapProps) => GapProps.height};
  @media only screen and (max-width: 768px) {
    height: ${(GapProps) =>
      GapProps.height2 ? GapProps.height2 : GapProps.height};
  }
`;

export default DynamicPromoForm;
